import {
  ACCESS_ITEM_NAME,
  ACCESS_ITEM_PATH,
  ACCESS_LIST_NAME,
  ACCESS_LIST_PATH,
  ACCOUNT_ITEM_NAME,
  ACCOUNT_ITEM_PATH,
  ACCOUNT_LIST_NAME,
  ACCOUNT_LIST_PATH,
  AGG_REPORT_ITEM_NAME,
  AGG_REPORT_ITEM_PATH,
  AGG_REPORT_LIST_NAME,
  AGG_REPORT_LIST_PATH,
  BASKET_LIST_NAME,
  BASKET_LIST_PATH,
  CHOISE_ACCOUNTS_NAME,
  CHOISE_ACCOUNTS_PATH,
  CHOISE_PERSONAL_ACCOUNTS_NAME,
  CHOISE_PERSONAL_ACCOUNTS_PATH,
  CURRENT_NAME,
  CURRENT_PATH,
  EPGU_ITEM_NAME,
  EPGU_ITEM_PATH,
  EPGU_LIST_NAME,
  EPGU_LIST_PATH,
  EPK_ITEM_NAME,
  EPK_ITEM_PATH,
  EPK_LIST_NAME,
  EPK_LIST_PATH,
  EPK_REPORT_ITEM_NAME,
  EPK_REPORT_ITEM_PATH,
  EPK_REPORT_LIST_NAME,
  EPK_REPORT_LIST_PATH,
  EXTRACT_CREATE_NAME,
  EXTRACT_CREATE_PATH,
  EXTRACT_ITEM_NAME,
  EXTRACT_ITEM_PATH,
  EXTRACT_ITEM_TYPE_RULE,
  EXTRACT_ITEM_TYPE_RULE_UUID,
  EXTRACT_ITEM_UUID_NAME,
  EXTRACT_LIST_NAME,
  EXTRACT_LIST_PATH,
  EXTRACT_NAME,
  EXTRACT_PATH,
  HEAD_ITEM_NAME,
  HEAD_ITEM_PATH,
  HEAD_LIST_NAME,
  HEAD_LIST_PATH,
  ORG_ITEM_NAME,
  ORG_ITEM_PATH,
  ORG_LIST_NAME,
  ORG_LIST_PATH,
} from '~packages/epk-front-router/routes.json';
import { RouterViewComponent } from '~packages/epk-front-shared/lib';

import lphRoutes from '../lph/routes';

export const defaultPath = EPK_LIST_PATH;

const accessRoutes = [
  {
    path: ACCESS_ITEM_PATH,
    name: ACCESS_ITEM_NAME,
    component: () => import('@/pages/AccessItem'),
  },
  {
    path: ACCESS_LIST_PATH,
    name: ACCESS_LIST_NAME,
    component: () => import('@/pages/AccessList'),
  },
];

const accountsRoutes = [
  {
    path: ACCOUNT_LIST_PATH,
    name: ACCOUNT_LIST_NAME,
    component: () => import('@/pages/AccountList'),
  },
  {
    path: ACCOUNT_ITEM_PATH,
    name: ACCOUNT_ITEM_NAME,
    component: () => import('@/pages/RegisterAccount'),
  },
  {
    path: CHOISE_ACCOUNTS_PATH,
    name: CHOISE_ACCOUNTS_NAME,
    component: () => import('@/pages/ChoicePersonalAccounts'),
  },
  {
    path: CHOISE_PERSONAL_ACCOUNTS_PATH,
    name: CHOISE_PERSONAL_ACCOUNTS_NAME,
    component: () => import('@/pages/ChaptersPersonalAccounts'),
  },
];

const aggReportsRoutes = [
  {
    name: AGG_REPORT_LIST_NAME,
    path: AGG_REPORT_LIST_PATH,
    component: () => import('@/pages/AggregatedData'),
  },
  {
    name: AGG_REPORT_ITEM_NAME,
    path: AGG_REPORT_ITEM_PATH,
    component: () => import('@/pages/AggregatedDataItem'),
  },
];

const epguRoutes = [
  {
    path: EPGU_LIST_PATH,
    name: EPGU_LIST_NAME,
    component: () => import('@/pages/RequestsUnified'),
  },
  {
    path: EPGU_ITEM_PATH,
    name: EPGU_ITEM_NAME,
    component: () => import('@/pages/RequestsUnified/ui'),
  },
];

const epksRoutes = [
  {
    path: EPK_LIST_PATH,
    name: EPK_LIST_NAME,
    component: () => import('@/pages/EpkList'),
  },
  {
    name: EPK_ITEM_NAME,
    path: EPK_ITEM_PATH,
    component: () => import('@/pages/HouseholdBookPage'),
  },
];

const epkReportsRoutes = [
  {
    path: EPK_REPORT_LIST_PATH,
    name: EPK_REPORT_LIST_NAME,
    component: () => import('@/pages/EpkReportList'),
    props: (route: { query: { period?: number } }) => ({
      query: route.query.period ? route.query.period : 1,
    }),
  },
  {
    name: EPK_REPORT_ITEM_NAME,
    path: EPK_REPORT_ITEM_PATH,
    component: () => import('@/pages/ConsolidatedHouseholdDetailed'),
    props: (route: { params: { id?: string } }) => ({
      id: route.params.id ? route.params.id : '',
    }),
  },
];

const extractsRoutes = [
  {
    path: EXTRACT_LIST_PATH,
    name: EXTRACT_LIST_NAME,
    component: () => import('@/pages/Statements'),
  },
  {
    path: `${EXTRACT_LIST_PATH}/i/:id`,
    name: EXTRACT_ITEM_TYPE_RULE,
    component: () => import('@/pages/ExtractTypeRulePage'),
  },
  {
    path: `${EXTRACT_LIST_PATH}/iu/:uuid`,
    name: EXTRACT_ITEM_TYPE_RULE_UUID,
    component: () => import('@/pages/ExtractTypeRulePage'),
  },
  {
    path: `${EXTRACT_LIST_PATH}/u/:uuid/:scope`,
    name: EXTRACT_ITEM_UUID_NAME,
    component: () => import('@/pages/ExtractsReportPage'),
  },
  {
    path: EXTRACT_ITEM_PATH,
    name: EXTRACT_ITEM_NAME,
    component: () => import('@/pages/ExtractsReportPage'),
  },
  {
    path: EXTRACT_CREATE_PATH,
    name: EXTRACT_CREATE_NAME,
    component: () => import('@/pages/ExtractCreate'),
  },
  {
    path: EXTRACT_PATH,
    name: EXTRACT_NAME,
    component: () => import('@/pages/Extract'),
  },
];

const headsRoutes = [
  {
    path: HEAD_LIST_PATH,
    name: HEAD_LIST_NAME,
    component: () => import('@/pages/RegisterChapters'),
  },
  {
    path: HEAD_ITEM_PATH,
    name: HEAD_ITEM_NAME,
    component: () => import('@/pages/ChapterInformation'),
  },
  {
    path: CURRENT_PATH,
    name: CURRENT_NAME,
    component: () => import('@/pages/Current'),
  },
];

const orgRoutes = [
  {
    path: ORG_LIST_PATH,
    name: ORG_LIST_NAME,
    component: () => import('@/pages/OrgList'),
  },
  {
    path: ORG_ITEM_PATH,
    name: ORG_ITEM_NAME,
    component: () =>
      import('~packages/epk-org-client').then(i => i.OrgItemPage),
  },
];

const basketRoutes = [
  {
    path: BASKET_LIST_PATH,
    name: BASKET_LIST_NAME,
    component: () => import('@/pages/Basket'),
  },
];

[accessRoutes, orgRoutes].forEach(arr => {
  arr.forEach(i => {
    const meta = (i.meta ??= {});
    meta.always = true;
  });
});

[headsRoutes, lphRoutes, extractsRoutes, epguRoutes, basketRoutes].forEach(
  arr => {
    arr.forEach(i => {
      const meta = (i.meta ??= {});
      meta.readWriteOnly = true;
    });
  }
);

export const routes = [
  ...accessRoutes,
  ...accountsRoutes,
  ...aggReportsRoutes,
  ...epguRoutes,
  ...epksRoutes,
  ...epkReportsRoutes,
  ...extractsRoutes,
  ...headsRoutes,
  ...lphRoutes,
  ...orgRoutes,
  ...basketRoutes,
  {
    path: '/__app-info',
    component: RouterViewComponent,
    children: [
      {
        path: '',
        name: 'AppInfo',
        component: () => import('@/pages/AppInfoPage'),
      },
    ],
  },
  {
    path: defaultPath,
    component: () =>
      import('@components/common/PersonalBlock/PersonalBlock.vue'),
  },
];
